import { Component, OnInit, OnDestroy, Input, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { NavigationService, Subscription } from '../core/navigation/navigation.service';
import { SubMenuService, SubMenuItem } from '../core/menu/sub-menu.service';

@Component({
	selector: 'hierarcical-menu',
	template: require('./hierarcical-menu.component.html')
})
export class HierarcicalMenuComponent   {

	constructor(private elementRef: ElementRef) {
	}

	@Input() items: SubMenuItem[];

	@Input() collapse: boolean;

	@Input() state: string[] = [];

	
	toggle(item: SubMenuItem) {
		const index = this.state.findIndex(x => x === item.id);

		if (index < 0) {
			this.state = new Array(item.id);
		}
			
		else {
			this.state = this.state.filter(x => x !== item.id);
		}

	}

	isOpen(item: SubMenuItem) : boolean {
		var isOpen = this.state.findIndex(x => x === item.id) > -1;
		return isOpen;

	}

	ensureCurrentLeafVisible(): void {
		
		setTimeout(() => {
			//console.log("ensure menuitem visible");

			const active = this.elementRef.nativeElement.querySelector('.active');
		
			if (active != null) {
				this.state = [];
				var parent = active;

				do {

					parent = parent.parentElement;

					if (parent.classList.contains("parent")) {

						this.state = this.state.concat(parent.id);
					}

				} while (parent.className !=="page-menu");
			}

		}, 100);
	}
	
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/hierarcical-menu.component.ts